function jklResolveAnchorId(hash) {
  if (!hash) return null;
  var id = hash.charAt(0) === "#" ? hash.slice(1) : hash;
  var glIndex = id.indexOf("?_gl=");
  if (glIndex > -1) id = id.substring(0, glIndex);
  if (!id) return null;
  return decodeURIComponent(id);
}

window.addEventListener("load", function () {
  var id = jklResolveAnchorId(window.__jklRawHash || window.location.hash);
  if (!id) return;
  var el = document.getElementById(id);
  if (el) el.scrollIntoView();
});

document.addEventListener("click", function (e) {
  var a = e.target.closest('a[href*="#"]');
  if (!a) return;

  var url;
  try {
    url = new URL(a.getAttribute("href"), window.location.href);
  } catch (err) {
    return;
  }

  if (
    url.origin !== window.location.origin ||
    url.pathname !== window.location.pathname ||
    !url.hash
  ) {
    return;
  }

  e.preventDefault();
  window.location.hash = url.hash;
  window.location.reload();
});
